import { render, staticRenderFns } from "./modalNotificaciones.vue?vue&type=template&id=466d4a4a&scoped=true&"
import script from "./modalNotificaciones.vue?vue&type=script&lang=js&"
export * from "./modalNotificaciones.vue?vue&type=script&lang=js&"
import style0 from "./modalNotificaciones.vue?vue&type=style&index=0&id=466d4a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d4a4a",
  null
  
)

export default component.exports